/**
 * Screen Saver navigation helpers.
 * Route remains `/ambient` internally; user-facing name is Screen Saver.
 */
import { ROUTES } from '../../utils/constants';

/**
 * @param {{ siteId?: string|null, returnTo?: string }} [options]
 * @returns {{ to: string, state: { returnTo: string } }}
 */
export function buildScreenSaverNavigation(options = {}) {
  const siteId = String(options.siteId || '').trim();
  const returnTo =
    typeof options.returnTo === 'string' && options.returnTo.startsWith('/')
      ? options.returnTo
      : ROUTES.HOME_LAUNCHER;
  const to = siteId
    ? `${ROUTES.AMBIENT}?siteId=${encodeURIComponent(siteId)}`
    : ROUTES.AMBIENT;
  return {
    to,
    state: { returnTo },
  };
}

/**
 * Navigate to Screen Saver without Flows/MQTT/backend actions.
 * @param {Function} navigate - react-router navigate
 * @param {{ siteId?: string|null, returnTo?: string }} [options]
 */
export function openScreenSaver(navigate, options = {}) {
  if (typeof navigate !== 'function') return;
  const { to, state } = buildScreenSaverNavigation(options);
  navigate(to, { state });
}
